import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@/ui';
import { useItemCardContext } from '../../context/useItemCardContext';
import { CopyOption } from './CopyOption';

type Props = {
  onDelete?: () => void;
  onEdit?: () => void;
};

export const MoreMenu = ({ onDelete, onEdit }: Props) => {
  const { entry, instance } = useItemCardContext();
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);
  const { t } = useTranslation('schedule', {
    keyPrefix: 'agenda_view.more_menu',
  });

  return (
    <Menu
      closeOnSelect={false}
      isLazy
      placement="bottom-end"
      onClose={() => setIsConfirmingDelete(false)}
    >
      {({ onClose }) => (
        <>
          <MenuButton
            aria-label={t('aria')}
            as={IconButton}
            colorScheme="dark"
            icon={<Icon icon="MoreHorizontal" size="5" />}
            size="sm"
            variant="ghost"
          />
          <Portal>
            <MenuList minW="175px">
              {onEdit && (
                <MenuItem
                  icon={<Icon icon="Pencil" />}
                  isDisabled={isConfirmingDelete}
                  onClick={() => {
                    onEdit();
                    onClose();
                  }}
                >
                  {t('edit')}
                </MenuItem>
              )}
              <CopyOption
                entry={entry}
                instance={instance}
                isDisabled={isConfirmingDelete}
                onClick={onClose}
              />
              {onDelete && (
                <MenuItem icon={<Icon icon="Trash" />} onClick={onDelete}>
                  {t('delete.delete')}
                </MenuItem>
              )}
            </MenuList>
          </Portal>
        </>
      )}
    </Menu>
  );
};
